import { nanoid } from 'nanoid';

import { Navigation } from 'interfaces';

export const getMenuLinks = () => {
  const menu = new Map<Navigation, Navigation[]>([
    [
      {
        title: 'Success stories',
        id: nanoid(),
      },
      [
        {
          title: 'Talenteer for software testing company',
          id: nanoid(),
          link: {
            uri: '/success-stories/talenteer-for-software-testing-company',
          },
        },
        {
          title: 'Internal talent marketplace for a global IT services company',
          id: nanoid(),
          link: {
            uri: 'https://www.itransition.com/portfolio/internal-talent-marketplace',
          },
        },
      ],
    ],
    [
      {
        title: 'Use cases',
        id: nanoid(),
      },
      [
        {
          title: 'How Talenteer’s AI matching works',
          id: nanoid(),
          link: {
            uri: '/use-cases/how-ai-matching-works',
          },
        },
        {
          title: 'Maximize productivity and engagement',
          id: nanoid(),
          link: {
            uri: '/use-cases/maximize-productivity-and-engagement',
          },
        },
        {
          title: 'Empower agile talent allocation',
          id: nanoid(),
          link: {
            uri: '/use-cases/empower-agile-talent-allocation',
          },
        },
        {
          title: 'Cultivate cost-efficiency',
          id: nanoid(),
          link: {
            uri: '/use-cases/cultivate-cost-efficiency',
          },
        },
        {
          title: 'Streamline in-house recruitment',
          id: nanoid(),
          link: {
            uri: '/use-cases/streamline-in-house-recruitment',
          },
        },
        {
          title: 'Embrace cross-functional collaboration',
          id: nanoid(),
          link: {
            uri: '/use-cases/embrace-cross-functional-collaboration',
          },
        },
      ],
    ],
    [
      {
        title: 'Blog',
        id: nanoid(),
        link: {
          uri: '/blog',
        },
      },
      [],
    ],
  ]);

  return menu;
};
